export default class Snackbar {
  static create({ text, duration, fullWidth = false }){
    let _duration = duration ? duration : 5000;
    let snackbar = new Snackbar({ text: text, duration: _duration, fullWidth: fullWidth});
    snackbar.init();
  } 

  constructor({text, duration, fullWidth}){
    this.duration = duration;
    this.element = this.createElement(text);
    this.fullWidth = fullWidth;
  }

  init(){
    this.appendToBody();
    this.show(this.fullWidth);
    this.hideDelay();
  }

  appendToBody(){
    document.body.appendChild(this.element);
  }

  show(){
    if (this.fullWidth) this.element.style.right = '20px';
    this.element.style.opacity = 1;
  }

  hideDelay(){
    window.setTimeout(this.hide.bind(this), this.duration);
  }

  hide(){
    this.element.style.opacity = 0;
    this.removeDelay();
  }

  removeDelay(){
    window.setTimeout(this.remove.bind(this), 1000);
  }

  remove(){
    this.element.remove();
  }

  createElement(text){
    let element = document.createElement('div');
    element.innerText = text;
    element.setAttribute('style', this.getStyle());
    return element;
  }

  getStyle(){
    return `position: fixed;
     display: block;
     background-color: rgba(0,0,0,0.8);
     bottom: 20px;
     left: 20px;
     color: #fff;
     padding: 5px 20px;
     border-radius: 4px;
     opacity: 0;
     transition: opacity 0.5s ease;
     z-index: 999;
     `
  }
}